import { getProjectId, getPublicationElements } from './utility'

import ky from 'ky'

export function initializeCtaClickReporting() {
    const publicationElements = getPublicationElements()
    for (const publicationElement of publicationElements) {
        const clickToActionElements = publicationElement.querySelectorAll('[data-cta]')
        const publicationId = publicationElement.dataset.publicationId as string

        for (const clickToActionElement of clickToActionElements) {
            ;(function (publicationId) {
                clickToActionElement.addEventListener('auxclick', function (e: MouseEventInit) {
                    if (e.button === 1) {
                        handleCtaClick(publicationId)
                    }
                })

                clickToActionElement.addEventListener('click', function (e) {
                    handleCtaClick(publicationId)
                })
            })(publicationId)
        }
    }
}

export function handleCtaClick(publicationId: string) {
    return ky.post(window.noticeable.pipelineBaseUrl + '/m/ncc', {
        json: {
            p: getProjectId(),
            q: publicationId,
        },
    })
}
